import React from 'react'
import SimulacionExportador from '../components/simulacionProyeccion/SimulacionExportador'

function SimulacionProyeccionExportador () {
  return (
    <SimulacionExportador />
  )
}

export default SimulacionProyeccionExportador
